// La Clica accessory: paletero brass bell.
// Silhouette = round bell + clapper + cord loop + small motion lines.
// The motion lines are the cultural cue — players hear the bell first; the
// silhouette has to imply sound. Cord loop suggests it's hanging off the cart.

interface PaleteroBellProps {
  /** Primary fill (bell body). Defaults to sodium-lamp orange. */
  bodyColor?: string;
  /** Accent fill (cord + clapper). Defaults to tecate gold. */
  accentColor?: string;
  /** Rendered size in px (square bounding box). */
  size?: number;
  /** Optional className for positioning. */
  className?: string;
}

export function PaleteroBell({
  bodyColor = '#ff8a3d',
  accentColor = '#d4a945',
  size = 48,
  className,
}: PaleteroBellProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      {/* Cord loop — hanging from above */}
      <path
        d="M22 4 Q24 2 26 4 L26 12 L22 12 Z"
        fill={accentColor}
      />
      {/* Bell yoke / cap */}
      <rect x="20" y="11" width="8" height="3" rx="1" fill={accentColor} />
      {/* Bell body — domed shape, slight asymmetry implies mid-swing */}
      <path
        d="M14 14 Q14 30 18 36 L30 36 Q34 30 34 14 Z"
        fill={bodyColor}
      />
      {/* Bell highlight — left edge */}
      <path
        d="M14 14 Q14 28 17 34"
        stroke="rgba(255,255,255,0.35)"
        strokeWidth="2"
        fill="none"
      />
      {/* Bell shadow — right edge */}
      <path
        d="M34 14 Q34 28 31 34"
        stroke="rgba(0,0,0,0.3)"
        strokeWidth="2"
        fill="none"
      />
      {/* Rim band */}
      <rect x="14" y="33" width="20" height="3" fill={accentColor} />
      {/* Clapper — visible at bottom, offset right (mid-ring) */}
      <circle cx="26" cy="40" r="3" fill={accentColor} />
      <rect x="25" y="32" width="2" height="6" fill="rgba(0,0,0,0.4)" />
      {/* Motion lines — implying ring */}
      <path
        d="M6 22 L10 22 M5 28 L9 28"
        stroke={bodyColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        opacity="0.6"
      />
      <path
        d="M38 22 L42 22 M39 28 L43 28"
        stroke={bodyColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        opacity="0.6"
      />
    </svg>
  );
}
